import { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../api/client';
import UserSiteActivityPanel, { formatDateTime } from '../components/UserSiteActivityPanel';

export default function TeacherNewUserActivityPage() {
  const { userId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get(`/teacher/new-users/${userId}/activity/`);
      setData(res.data);
    } catch (e) {
      setData(null);
      setError(
        e.response?.status === 403
          ? 'Раздел доступен только администратору сайта.'
          : e.response?.status === 404
            ? 'Пользователь не найден.'
            : e.response?.data?.detail || 'Не удалось загрузить активность.',
      );
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    load();
  }, [load]);

  const user = data?.user;

  return (
    <div className="teacher-new-users-page teacher-new-user-activity-page">
      <div className="page-header">
        <p>
          <Link to="/teacher/new-users" className="back-link">← Новые пользователи</Link>
        </p>
        <h1>
          {user
            ? `Активность: ${user.display_name || user.first_name || user.username}`
            : 'Активность посетителя'}
        </h1>
        {user && (
          <p className="page-subtitle">
            @{user.username}
            {user.contact_display ? ` · ${user.contact_display}` : ''}
            {' · '}зарегистрирован {formatDateTime(user.date_joined)}
          </p>
        )}
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {loading ? (
        <div className="loading-screen">
          <div className="spinner" />
          <p>Загрузка...</p>
        </div>
      ) : data ? (
        <UserSiteActivityPanel
          data={data}
          showAttemptsJournalLink
          showIsMyStudent
        />
      ) : null}
    </div>
  );
}
